// Mirrors Tp_Communication.Constant.TpPlatformInvoiceConstants.CostTypes — keep in sync.
const TpPlatformInvoiceCostTypesEnum = {
  ShopInstance: 'ShopInstance',
  Programming: 'Programming',
  Recording: 'Recording',
  AdditionalFee: 'AdditionalFee',
  CommentCard: 'CommentCard',
  Audit: 'Audit',
  Text: 'Text',
  VirtualNumber: 'VirtualNumber',
};

// Grid display labels; an unknown value falls back to the raw cost type.
export const TpPlatformInvoiceCostTypeLabels = {
  [TpPlatformInvoiceCostTypesEnum.ShopInstance]: 'Shop Instance',
  [TpPlatformInvoiceCostTypesEnum.Programming]: 'Programming',
  [TpPlatformInvoiceCostTypesEnum.Recording]: 'Recording',
  [TpPlatformInvoiceCostTypesEnum.AdditionalFee]: 'Additional Fee',
  [TpPlatformInvoiceCostTypesEnum.CommentCard]: 'Comment Card',
  [TpPlatformInvoiceCostTypesEnum.Audit]: 'Audit',
  [TpPlatformInvoiceCostTypesEnum.Text]: 'Texts',
  [TpPlatformInvoiceCostTypesEnum.VirtualNumber]: 'Virtual Numbers',
};

export default TpPlatformInvoiceCostTypesEnum;
